import { connect } from 'react-redux';
import View from './PriceChangesView';
import { goalId as selectedGoalId } from '../../../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownSelector';
import RouteDictionary from '../../WhatIfsRouteDictionary';
import { dynamicFieldSelector, givingStrategySelector } from './PriceChangesSelector';
import {
  applyWhatIf,
  fetchWhatIfOptions,
  initialPlanImpact,
  updateWhatIfsData,
  planImpact,
} from '../../WhatIfsActions';
import {
  loading,
  nullableFpIdSelector,
  areOptionsLoaded,
  whatIfInnerSelector,
  whatIfTemplateInnerSelector,
  nullableTitleSelector,
  nullableGroupTitleSelector,
  impactSelector,
} from '../../WhatIfsSelector';

const mapStateToProps = (state, ownProps) => {
  const whatIfTemplate = whatIfTemplateInnerSelector(state, ownProps);
  return {
    fpId: nullableFpIdSelector(state, ownProps),
    goalId: selectedGoalId(state, ownProps),
    areOptionsLoaded: areOptionsLoaded(state, ownProps),
    whatIf: whatIfInnerSelector(state, ownProps),
    whatIfTemplate,
    loading: loading(state, ownProps),
    title: nullableTitleSelector(state, ownProps),
    groupTitle: nullableGroupTitleSelector(state, ownProps),
    planImpactItems: impactSelector(state, ownProps),
    purchasePrice: dynamicFieldSelector(state, { ...ownProps, whatIfTemplate }),
    givingStrategy: givingStrategySelector(state, ownProps),
  };
};

const mapDispatchToProps = dispatch => ({
  storeData: (goalId, whatIfType) => (data, clientId) => {
    dispatch(updateWhatIfsData(clientId, goalId, whatIfType, data));
  },
  fetchInitialPlanImpact: (clientId, fpId, goalId, whatIf, whatIfTemplate) => {
    dispatch(
      initialPlanImpact(
        clientId,
        fpId,
        goalId,
        whatIf,
        RouteDictionary[whatIfTemplate.WhatIfType],
        Object.keys(whatIfTemplate),
        whatIfTemplate.WhatIfType,
      ),
    );
  },
  fetchPlanImpact: (clientId, fpId, goalId, whatIf, whatIfTemplate) => {
    dispatch(
      planImpact(
        clientId,
        fpId,
        goalId,
        whatIf,
        RouteDictionary[whatIfTemplate.WhatIfType],
        Object.keys(whatIfTemplate),
        whatIfTemplate.WhatIfType,
      ),
    );
  },
  fetchData: (clientId, fpId, goalId, whatIfType) => {
    dispatch(fetchWhatIfOptions(clientId, fpId, goalId, RouteDictionary[whatIfType], whatIfType));
  },
  applyWhatIf: (clientId, fpId, goalId, whatIf, whatIfTemplate) => () => {
    dispatch(
      applyWhatIf(
        clientId,
        fpId,
        goalId,
        whatIf,
        RouteDictionary[whatIfTemplate.WhatIfType],
        Object.keys(whatIfTemplate),
        whatIfTemplate.WhatIfType,
      ),
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
